export enum EProtections {
  TRIP_INSURANCE = 'trip-insurance',
  DAMAGE_PROTECTION = 'damage-protection',
  WEATHER_PROTECTION = 'weather',
}

export enum EServiceTypes {
  ROADSIDE_ASSISTANCE = 'roadside',
}
